export const RemoveExtraSpace = (s) => s.trim().split(/ +/).join(' ');
